import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { toast } from "sonner";
import { api } from "@/lib/api";
import Reveal from "@/components/Reveal";

const TILES = [
  { id: "rouge", label: "Vins rouges", image: "/assets/mockup/cat-rouge.jpg", testId: "category-tile-vins-rouges" },
  { id: "blanc", label: "Vins blancs", image: "/assets/mockup/cat-blanc.jpg", testId: "category-tile-vins-blancs" },
  { id: "champagne", label: "Champagnes", image: "/assets/mockup/cat-champagne.jpg", testId: "category-tile-champagnes" },
  { id: "coffret", label: "Coffrets cadeaux", image: "/assets/mockup/cat-coffret.jpg", testId: "category-tile-coffrets" },
];

export default function CategoryTiles() {
  const navigate = useNavigate();
  const [counts, setCounts] = useState(null);

  useEffect(() => {
    api
      .get("/wines")
      .then((res) => {
        const map = {};
        res.data.forEach((w) => (map[w.category] = (map[w.category] || 0) + 1));
        setCounts(map);
      })
      .catch(() => setCounts({}));
  }, []);

  return (
    <section className="px-[2.4cqw] pt-[3cqw]" data-testid="categories-section">
      <div className="grid grid-cols-4 gap-[2.2cqw]">
        {TILES.map((tile, i) => {
          const empty = counts !== null && !counts[tile.id];
          return (
            <Reveal key={tile.id} delay={i * 0.06}>
              <motion.button
                onClick={() => {
                  if (empty) {
                    toast.info(`${tile.label} : prochainement à la carte`);
                    return;
                  }
                  navigate(`/vins?cat=${tile.id}`);
                }}
                className={`group w-full text-center ${empty ? "cursor-default" : ""}`}
                whileHover={empty ? undefined : { y: -4, rotate: i % 2 === 0 ? -0.8 : 0.8 }}
                whileTap={empty ? undefined : { scale: 0.96 }}
                transition={{ duration: 0.25 }}
                data-testid={tile.testId}
                aria-disabled={empty}
              >
                <span className="relative block rounded-[2.2cqw] overflow-hidden lifted">
                  <img
                    src={tile.image}
                    alt={tile.label}
                    loading="lazy"
                    className={`w-full h-full object-cover no-frame block ${empty ? "opacity-80" : ""}`}
                    style={{ aspectRatio: "174 / 162" }}
                  />
                  {empty && (
                    <span
                      className="absolute inset-x-0 bottom-[1.4cqw] text-center font-eyebrow text-[1.7cqw] tracking-[0.25em] uppercase text-[#FAF6F0]/90 italic"
                      style={{ textShadow: "0 1px 5px rgba(0, 0, 0, 0.5)" }}
                      data-testid="category-tile-prochainement"
                    >
                      Prochainement
                    </span>
                  )}
                </span>
                <span className="block mt-[2cqw] font-display text-[3cqw] font-semibold text-[#1C1917] leading-tight group-hover:text-[#6B1226] transition-colors">
                  {tile.label}
                </span>
              </motion.button>
            </Reveal>
          );
        })}
      </div>
    </section>
  );
}
